import './Hero.css';
import { Link } from 'react-router-dom';
import { FaAmbulance, FaCalendarAlt, FaPhoneAlt } from 'react-icons/fa';
import { company } from '../content/companyContent';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <p className="hero-kicker">{company.formerName}</p>
        <h1>{company.name}</h1>
        <p>{company.tagline}</p>
        <div className="hero-buttons">
          <Link to="/appointment" className="btn btn-primary">
            <FaCalendarAlt /> Book Appointment
          </Link>
          <Link to="/contact" className="btn btn-secondary">
            <FaPhoneAlt /> {company.phone}
          </Link>
        </div>
        <div className="hero-highlights" aria-label="Key service strengths">
          <span>Diagnostics</span>
          <span>24/7 Ambulance</span>
          <span>Hospital CRM</span>
          <span>TPA Liaison</span>
        </div>
      </div>
      <div className="hero-logo-panel">
        <img src="/logo.png" alt={company.legalName} />
        <div className="emergency-strip">
          <FaAmbulance />
          <span>Emergency response and healthcare logistics support</span>
        </div>
      </div>
    </section>
  );
}

export default Hero;
